import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import NavBar from './components/NavBar'
import PipelineAlert from './components/PipelineAlert'
import ProtectedRoute from './components/ProtectedRoute'

// Route-level code splitting: each page becomes its own chunk loaded on
// navigation, so the initial bundle no longer ships every view at once.
const AccountsPage = lazy(() => import('./views/AccountsPage'))
const MarketPredictionPage = lazy(() => import('./views/MarketPredictionPage'))
const MarketPage = lazy(() => import('./views/MarketPage'))
const StockPage = lazy(() => import('./views/StockPage'))
const LoginPage = lazy(() => import('./views/LoginPage'))
const SettingsPage = lazy(() => import('./views/SettingsPage'))
const StrategyPage = lazy(() => import('./views/StrategyPage'))
const WatchlistPage = lazy(() => import('./views/WatchlistPage'))
const FuturesPage = lazy(() => import('./views/FuturesPage'))
const SystemPage = lazy(() => import('./views/SystemPage'))
const TrainingResultsPage = lazy(() => import('./views/TrainingResultsPage'))
const MarketOpenSimPage = lazy(() => import('./views/MarketOpenSimPage'))
const ReplayPage = lazy(() => import('./views/ReplayPage'))
const ScreenerPage = lazy(() => import('./views/ScreenerPage'))
const TopNPage = lazy(() => import('./views/TopNPage'))
const KolPage = lazy(() => import('./views/KolPage'))
const ExperimentPage = lazy(() => import('./views/ExperimentPage'))
const OpenBookPage = lazy(() => import('./views/OpenBookPage'))
const MaVolPage = lazy(() => import('./views/MaVolPage'))

export default function App() {
  return (
    <Suspense fallback={<div className="text-muted" style={{ padding: 24 }}>載入中…</div>}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <div className="layout">
                <NavBar />
                {/* Wrap PipelineAlert + main in a column so the flex-row layout
                    doesn't turn PipelineAlert into a vertical sidebar column. */}
                <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0, overflow: 'hidden' }}>
                  <PipelineAlert />
                  <main className="main">
                  <Routes>
                    {/* ── Core routes ── */}
                    {/* Home = 自動交易（操作中樞）。大盤預測是實驗記分板，2026-07-13
                        審視後降級到 /prediction — 26 個結算日實測無 edge 的預測面板
                        不該佔首頁位置暗示交易參考價值。 */}
                    <Route path="/"                   element={<WatchlistPage />} />
                    <Route path="/prediction"         element={<MarketPredictionPage />} />
                    <Route path="/market"             element={<MarketPage />} />
                    <Route path="/stock"              element={<StockPage />} />
                    <Route path="/watchlist"          element={<WatchlistPage />} />
                    <Route path="/accounts"           element={<AccountsPage />} />
                    <Route path="/accounts/:accountId" element={<AccountsPage />} />
                    <Route path="/strategy"           element={<StrategyPage />} />
                    <Route path="/settings"           element={<SettingsPage />} />
                    {/* Futures kept but not in nav — accessible via direct URL */}
                    <Route path="/futures"            element={<FuturesPage />} />
                    <Route path="/experiment"         element={<ExperimentPage />} />
                    {/* ── Redirects for removed/merged pages ── */}
                    <Route path="/lab"           element={<Navigate to="/strategy" replace />} />
                    <Route path="/signals"       element={<Navigate to="/strategy" replace />} />
                    <Route path="/strategies"    element={<Navigate to="/strategy" replace />} />
                    <Route path="/backtest"      element={<Navigate to="/strategy" replace />} />
                    <Route path="/shioaji"       element={<Navigate to="/settings" replace />} />
                    <Route path="/users"         element={<Navigate to="/settings" replace />} />
                    <Route path="/training"      element={<Navigate to="/training-results" replace />} />
                    <Route path="/training-results" element={<TrainingResultsPage />} />
                    <Route path="/screener"      element={<ScreenerPage />} />
                    <Route path="/topn"          element={<TopNPage />} />
                    <Route path="/kol"           element={<KolPage />} />
                    <Route path="/open-book"     element={<OpenBookPage />} />
                    <Route path="/ma-vol"        element={<MaVolPage />} />
                    <Route path="/gooaye"        element={<Navigate to="/kol" replace />} />
                    <Route path="/market-sim"    element={<MarketOpenSimPage />} />
                    <Route path="/replay"        element={<ReplayPage />} />
                    <Route path="/system"        element={<SystemPage />} />
                    <Route path="/training-guide" element={<Navigate to="/training-results" replace />} />
                    <Route path="/fundamentals"  element={<Navigate to="/" replace />} />
                    <Route path="/audit"         element={<Navigate to="/" replace />} />
                    <Route path="/audit/:runId"  element={<Navigate to="/" replace />} />
                    <Route path="/ops"           element={<Navigate to="/" replace />} />
                    <Route path="/pipeline"      element={<Navigate to="/" replace />} />
                    <Route path="*"              element={<p className="text-muted">找不到頁面。</p>} />
                  </Routes>
                </main>
                </div>
              </div>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Suspense>
  )
}
